import React from "react";

const PoolIcon = ({ className = "" }: { className?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="25"
    fill="none"
    viewBox="0 0 24 25"
    className={className}
  >
    <path
      stroke="#354052"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="m6 11.325 4-2 3.5 3-1.5 2m-9 2.75a2.4 2.4 0 0 0 1 .25 2.4 2.4 0 0 0 2-1 2.4 2.4 0 0 1 2-1 2.4 2.4 0 0 1 2 1 2.4 2.4 0 0 0 2 1 2.4 2.4 0 0 0 2-1 2.4 2.4 0 0 1 2-1 2.4 2.4 0 0 1 2 1 2.4 2.4 0 0 0 2 1 2.4 2.4 0 0 0 1-.25m-6-7.75a1 1 0 1 0 2 0 1 1 0 0 0-2 0"
    ></path>
  </svg>
);

export default PoolIcon;
